import { useId, type ReactNode } from 'react';

/**
 * O formulario de pagina inteira como o exemplo da R01 (p.28) o desenha: um
 * CARD branco, com as secoes separadas por divisoria e a barra de acoes no
 * rodape dele. Serve o cadastro de equipamento e os tres formularios do
 * catalogo.
 *
 * O card tem a largura maxima do formulario (1280 px, R01) e ocupa a area de
 * conteudo ate ela. A barra de acoes, dentro dele, leva `px-6`: a mesma margem
 * interna das secoes, para o botao nao encostar na borda.
 */
export const CARTAO_DE_FORMULARIO =
  'cartao flex w-full max-w-[var(--form-max)] flex-col';

/** Barra de acoes no rodape do card: fixa ao rolar (R01, p.28) e com respiro. */
export const BARRA_DO_CARTAO = 'barra-de-acoes rounded-b-card px-6';

/**
 * Uma secao do formulario: titulo acima, campos na grade 3 -> 2 -> 1 da R01.
 * A primeira nao leva divisoria em cima; as outras, sim.
 */
export function SecaoDoFormulario({
  titulo,
  primeira = false,
  children,
}: {
  /** Identificacao, Especificacao, Medicao... Sem titulo quando a secao e a unica. */
  readonly titulo?: string;
  readonly primeira?: boolean;
  readonly children: ReactNode;
}) {
  const id = useId();

  return (
    <section
      {...(titulo ? { 'aria-labelledby': id } : {})}
      className={`flex flex-col gap-4 p-6 ${primeira ? '' : 'border-t border-borda-sutil'}`}
    >
      {titulo ? (
        <h2 id={id} className="txt-subtitulo text-tinta">
          {titulo}
        </h2>
      ) : null}
      <div className="formulario-grade">{children}</div>
    </section>
  );
}
